var _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvantage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9048 0.00012207H31.928C32.6322 0.00012207 33.1158 0.708587 32.8593 1.3644L29.5098 9.92749C29.2533 10.5833 29.7369 11.2918 30.4411 11.2918H33.9962C34.8905 11.2918 35.3351 12.3759 34.6984 13.0038L18.7619 28.719C17.9942 29.476 16.7371 28.6496 17.1277 27.6446L20.6551 18.5708C20.9099 17.9152 20.4263 17.2084 19.723 17.2084H16.8231C16.1402 17.2084 15.6582 16.5392 15.8746 15.8915L20.9564 0.683202C21.0927 0.275214 21.4747 0.00012207 21.9048 0.00012207Z",
    fill: "#B068EE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.03613,
    y1: 7.21527,
    x2: 14.9447,
    y2: 7.21527,
    stroke: "#B068EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 13.877,
    x2: 12.3328,
    y2: 13.877,
    stroke: "#B068EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.40332,
    y1: 20.8885,
    x2: 14.9449,
    y2: 20.8885,
    stroke: "#B068EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage1);
export default __webpack_public_path__ + "static/media/advantage-1.40f5afd7c3a2d4c70914453040908835.svg";
export { ForwardRef as ReactComponent };